import { Fragment } from "react";
import Input from "../../../form/Input";

export const HomePageForm = ({
  values,
  handleChange,
  errors,
  formValidate,
}) => {
  const maxLength = 17;

  return (
    <Fragment>
      <div className="mb-4">
        <h4 className="font-semibold text-lg mb-2">SubContent Section</h4>
        <div className="grid grid-cols-12 gap-4">
          <div className="relative col-span-6">
            <Input
              label="Testimonial Title"
              inputPlaceholder="Enter Testimonial Title"
              inputName="testimonialTitle"
              value={values?.testimonialTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "testimonialTitle")}
            />
          </div>
          <div className="relative col-span-6">
            <Input
              label="Testimonial Description"
              inputPlaceholder="Enter Description"
              inputName="testimonialDesc"
              value={values?.testimonialDesc || ""}
              onChange={handleChange}
              {...formValidate(errors, "testimonialDesc")}
            />
          </div>
          <div className="relative col-span-6">
            <Input
              label="Partner Title"
              inputPlaceholder="Enter Partner Title"
              inputName="partnerlTitle"
              value={values?.partnerTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "partnerlTitle")}
            />
          </div>
          <div className="relative col-span-6">
            <Input
              label="Partner Description"
              inputPlaceholder="Enter Partner Description"
              inputName="partnerDesc"
              value={values?.partnerDesc || ""}
              onChange={handleChange}
              {...formValidate(errors, "partnerDesc")}
            />
          </div>
        </div>
      </div>

      <div className="my-4">
        <h4 className="font-semibold text-lg mb-2">Statistic Section</h4>
        <div className="grid grid-cols-12 gap-4">
          <div className="relative col-span-3">
            <Input
              label="Title"
              inputPlaceholder="Enter Title"
              inputName="existenceTitle"
              value={values?.existenceTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "existenceTitle")}
            />
          </div>
          <div className="relative col-span-3">
            <Input
              label="Count"
              inputPlaceholder="Enter Count"
              inputName="existenceCount"
              value={values?.existenceCount || ""}
              maxLength={maxLength}
              onChange={handleChange}
              {...formValidate(errors, "existenceCount")}
            />
            <div className="text-xs mt-1">
              {maxLength - (values?.existenceCount?.length || 0)} characters
              remaining
            </div>
          </div>
          <div className="relative col-span-3">
            <Input
              label="Title"
              inputPlaceholder="Enter Title"
              inputName="scholarAwardTitle"
              value={values?.scholarAwardTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "scholarAwardTitle")}
            />
          </div>
          <div className="relative col-span-3">
            <Input
              label="Count"
              inputPlaceholder="Enter Count"
              inputName="scholarAwardCount"
              value={values?.scholarAwardCount || ""}
              onChange={handleChange}
              maxLength={maxLength}
              {...formValidate(errors, "scholarAwardCount")}
            />
            <div className="text-xs mt-1">
              {maxLength - (values?.scholarAwardCount?.length || 0)} characters
              remaining
            </div>
          </div>
          <div className="relative col-span-3">
            <Input
              label="Title"
              inputPlaceholder="Enter Title"
              inputName="beneficiaryTitle"
              value={values?.beneficiaryTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "beneficiaryTitle")}
            />
          </div>
          <div className="relative col-span-3">
            <Input
              label="Count"
              inputPlaceholder="Enter Count"
              inputName="beneficiaryCount"
              value={values?.beneficiaryCount || ""}
              maxLength={maxLength}
              onChange={handleChange}
              {...formValidate(errors, "beneficiaryCount")}
            />
            <div className="text-xs mt-1">
              {maxLength - (values?.beneficiaryCount?.length || 0)} characters
              remaining
            </div>
          </div>
          <div className="relative col-span-3">
            <Input
              label="Title"
              inputPlaceholder="Enter Title"
              inputName="fundDistributionTitle"
              value={values?.fundDistributionTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "fundDistributionTitle")}
            />
          </div>
          <div className="relative col-span-3">
            <Input
              label="Count"
              inputPlaceholder="Enter Count"
              inputName="fundDistributionCount"
              maxLength={maxLength}
              value={values?.fundDistributionCount || ""}
              onChange={handleChange}
              {...formValidate(errors, "fundDistributionCount")}
            />
            <div className="text-xs mt-1">
              {maxLength - (values?.fundDistributionCount?.length || 0)}{" "}
              characters remaining
            </div>
          </div>
        </div>
      </div>

      <div className="my-4">
        <h4 className="font-semibold text-lg mb-2">Video Section</h4>
        <div className="grid grid-cols-12 gap-4">
          <div className="relative col-span-6">
            <Input
              label="Video Title"
              inputPlaceholder="Enter Video Title"
              inputName="videoSectionTitle"
              value={values?.videoSectionTitle || ""}
              onChange={handleChange}
              {...formValidate(errors, "videoSectionTitle")}
            />
          </div>
          <div className="relative col-span-6">
            <Input
              label="Video Link"
              inputPlaceholder="Enter Video Link"
              inputName="videoSectionDesc"
              value={values?.videoSectionDesc || ""}
              onChange={handleChange}
              {...formValidate(errors, "videoSectionDesc")}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};
